import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { apiRequest } from '../api';
import { queryKeys } from '../queryKeys';
import type { NewHire } from '../types';

export type NewHireInput = {
  name: string;
  email?: string;
  review_start?: string;
  review_end?: string;
  buddy1?: string;
  buddy2?: string;
  region?: string;
};

export function useNewHires() {
  return useQuery({
    queryKey: queryKeys.newHires,
    queryFn: () => apiRequest<NewHire[]>('/api/new-hires'),
  });
}

export function useCreateNewHire() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: NewHireInput) => apiRequest<NewHire>('/api/new-hires', { method: 'POST', body: input }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.newHires }),
  });
}

export function useUpdateNewHire() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, patch }: { id: number; patch: Partial<NewHire> }) =>
      apiRequest<NewHire>(`/api/new-hires/${id}`, { method: 'PATCH', body: patch }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.newHires }),
  });
}

export function useDeleteNewHire() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => apiRequest<void>(`/api/new-hires/${id}`, { method: 'DELETE' }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.newHires }),
  });
}
